import mainSelect from "@/components/atoms/main-select/index.vue";
import store from "@/store";
import { mapGetters } from "vuex";

const LS_SORT_KEY = 'courses.sort';
const LS_CAT_KEY  = 'courses.category';

export default {
	name		: "head-filter",
	props		: {
		routeName			: {
			type: String,
		},
		title				: {
			type: String,
			default: "",
		},
		listLength			: {},
		list				: {
			default: [],
		},
		moduleStore			: {
			type: String,
		},
		isLoadingCategories	: {
			type: Boolean,
			default: false,
		},
		categories			: {},
	},
	data() {
		return {
			filtersList		: [
				{
					id	: "0",
					name: "sortByDate",
				},
				{
					id	: "1",
					name: "sortByName",
				},
				{
					id	: "2",
					name: "sortByProgress",
				},
				{
					id	: "3",
					name: "sortByDiploma",
				},
				{
					id	: "4",
					name: "sortByRating",
				},
			],
			activeCategory	: {
				name: this.$t("together"),
				id	: "",
			},
			payload			: {
				status: {
					id	: "0",
					name: "sortByDate"
				},
			},
		};
	},
	components	: {
		mainSelect,
	},
	watch		: {
		categories: {
			handler() {
				setTimeout(() => {
					this.activeCategory = this.formattedCategories.find(
						(e) =>
							e.name.toLowerCase() === this.$route.query.category ||
							e.key === this.$route.query.category
					);
					
					this.payload.status = this.filtersList.find(
						(e) =>
							e.name === this.$route.query.sort ||
							e.name === this.$route.query.sort ||
							""
					);
					
					this.changeCategory(
						(this.activeCategory && this.activeCategory.id) || ""
					);
					
					this.changeSort(this.payload.status.name);
					
					if (!this.isListLoading) {
						this.$emit("fetch-data");
					}
				}, 10);
			},
			deep: true,
		},
	},
	created() {
		this.init();
	},
	computed	: {
		...mapGetters({
			isListLoading	: "courses/isListLoading",
		}),
		formattedCategories() {
			return [
				{
					name	: this.$t("together"),
					key		: "all",
					id		: "",
				},
				...this.categories,
			];
		},
	},
	methods		: {
		init() {
			//console.log('init:');
			
			if (this.$route.query.hasOwnProperty("sort")) {
				//console.log('1');
				
				this.payload.status = this.filtersList.find(
					(e) =>
						e.name === this.$route.query.sort ||
						e.name === this.$route.query.sort ||
						""
				);
			} else {
				const savedSort = localStorage.getItem(LS_SORT_KEY) || "sortByDate";
				
				//console.log('savedSort:', savedSort);
				
				this.payload.status = this.filtersList.find(e => e.name === savedSort) || this.filtersList[0];
				
				let query = {
					sort: savedSort
				};
				
				this.$router.replace({
					name	: this.routeName,
					query	: Object.assign(
						{},
						this.$route.query,
						query
					)
				});
			}
			
			if (this.$route.query.hasOwnProperty("category")) {
				//console.log('2');
				
				this.activeCategory = this.formattedCategories.find(
					(e) =>
						e.name.toLowerCase() === this.$route.query.category ||
						e.key === this.$route.query.category ||
						""
				);
			} else {
				const savedCategory = localStorage.getItem(LS_CAT_KEY);
				
				if(savedCategory){
					this.activeCategory = {
						key : savedCategory
					};
				}else{
					this.activeCategory = this.formattedCategories[0];
				}
				
				//console.log('savedCategory:', savedCategory);
				//console.log('activeCategory:', this.activeCategory);
				
				let query = {
					category:
						this.activeCategory.key || this.activeCategory.name.toLowerCase(),
				};
				
				this.$router.replace({
					name	: this.routeName,
					query	: Object.assign(
						{},
						this.$route.query,
						query
					)
				});
			}
			
			if (!this.categories.length && !this.isLoadingCategories) {
				this.changeCategory(this.activeCategory.id);
				
				if (!this.isListLoading) {
					this.$emit("fetch-data");
				}
			}
		},
		changeSelect() {
			//console.log('changeSelect:', this.activeCategory);
			
			if (!this.activeCategory){
				localStorage.setItem(LS_CAT_KEY, null);
				
				return;
			}
			
			if (this.activeCategory.name.toLowerCase() === this.$route.query.category){
				return;
			}
			
			let query = {
				category:
					this.activeCategory.key || this.activeCategory.name.toLowerCase(),
			};
			
			localStorage.setItem(
				LS_CAT_KEY, 
				query.category
			);
			
			this.changeCategory(this.activeCategory.id);
			
			this.$router.replace({
				name	: this.routeName,
				query	: Object.assign(
					{},
					this.$route.query,
					query
				)
			});
			
			if (!this.isListLoading) {
				this.$emit("fetch-data");
			}
		},
		changeCategory(params) {
			//console.log('changeCategory:', params);
			
			store.commit(`${this.moduleStore}/CHANGE_CATEGORY`, params);
		},
		changeSort(params) {
			//console.log('changeSort:', params);
			
			store.commit(`${this.moduleStore}/CHANGE_SORT`, params);
		},
		onChangeSort() {
			//console.log('onChangeSort:', this.payload.status);
			
			let query = {
				sort: this.payload.status.name
			};
			
			this.changeSort(this.payload.status.name);
			
			localStorage.setItem(LS_SORT_KEY, this.payload.status.name);
			
			this.$router.replace({
				name	: this.routeName,
				query	: Object.assign(
					{},
					this.$route.query,
					query
				)
			});
			
			if (!this.isListLoading) {
				this.$emit("fetch-data");
			}
		},
	},
};
